import { K8sProvider } from '@cast/shared-types';
import {
  SecurityInsightsPackage,
  SecurityInsightsContainerImageVulnerability,
  SecurityInsightsContainerImagePackage,
  Node,
  Anomaly,
  Cluster,
  OrganizationMember,
} from '@cast/types';

import { ClusterWithSchedules } from 'features/scheduled-rebalancing/types';

type VulnerabilityStatus = 'active' | 'excepted';

type VulnerabilityPackage = SecurityInsightsPackage & {
  vulnerabilityStatus?: VulnerabilityStatus;
};

export type ImageVulnerability = Omit<
  SecurityInsightsContainerImageVulnerability,
  'package'
> & {
  vulnerabilityStatus?: VulnerabilityStatus;
  package: VulnerabilityPackage;
};

export type ImagePackage = SecurityInsightsContainerImagePackage & {
  vulnerabilityStatus: VulnerabilityStatus;
};
export enum ImageVulnerabilitiesTabEnum {
  VULNERABILITIES = 'vulnerabilities',
  PACKAGES = 'packages',
}

export enum UpdatesStatus {
  ON = 'on',
  OFF = 'off',
  UNAVAILABLE = 'unavailable',
  UNKNOWN = 'unknown',
}

export enum AgeGroup {
  MORE_THAN_MONTH = 'old',
  UP_TO_MONTH = 'month',
  UP_TO_WEEK = 'week',
}

export type PreparedNode = {
  id: string;
  name: string;
  cluster: ClusterWithSchedules;
  created: string;
  os: string;
  osVersion: string;
  managedBy: string;
  provider: K8sProvider;
  updatesStatus: UpdatesStatus;
  ageGroup: AgeGroup;
  timeAgo: {
    formattedDate: string;
    distance: string;
  };
  orig: Node;
};

export type EnhancedAnomaly = Anomaly & {
  cluster?: Cluster;
  user?: OrganizationMember;
};
